import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { APPROVAL_PLACEHOLDERS, ApprovalStatus, ASSET_PLACEHOLDERS, AssetStatus, ISearchData, paginationChange, ROUTES, TICKET_PLACEHOLDERS, TICKET_PRIORITIES, TicketStatus } from '@common/interfaces';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { PaginationComponent } from '../pagination/pagination.component';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  @Input() fieldArray!: Array<{
    fieldName: string;
    type: string;
    keyType: string;
    key: any;
    icon: string;
  }>;
  @Input() tableDetails!: any[];
  @Input() displayTicketList!: boolean;
  @Input() tableData: any;
  @Input() pages: number[] = [];
  @Input() pagination: boolean = false;
  @Input() tableConfig: any;
  @Input() title!: string;
  @Input() searchOptions!: { title: string; value: string }[];
  @Input() count!: number;
  @Input() projectFilter!: boolean;
  @Input() vendorFilter!: boolean;
  @Input() reload = new EventEmitter<boolean>();
  data!: any;
  @Output() tableNavigationClick = new EventEmitter<string>();
  @Output() searchData = new EventEmitter<ISearchData>();
  @Output() paginatorEmitter = new EventEmitter<any>();
  @Input() filterOptions!: any[];
  @Input('activeMenu') pageCount: string = '5';
  @Output() activeFilter = new EventEmitter<string>();
  @Output() pageSizeChange = new EventEmitter<string>();
  @Output() deleteProject = new EventEmitter<string>();
  @Output() editVendor = new EventEmitter<any>();
  @Output() deleteVendor = new EventEmitter<any>();
  status!: string;
  @Input() counterText = '';
  filterStateOptions: { title: string; value: string }[] = [];
  pageSize = 5;
  hideFilters!: boolean;
  ticketStatusFilter!: boolean;
  approvalFilter!: boolean;
  loanStatusFilter!: boolean;
  workspaceFilter!: boolean;
  approvalsFilter!: boolean;
  statusFilter!: string[];
  displayColorCode: boolean = true;
  isAdmin!: boolean;
  isUser!: boolean;
  isSemiAdmin!: boolean;
  isEkoAdmin!: boolean;
  ROUTES = ROUTES;
  placeholderTitle = 'No tickets generated yet';
  placeholderSubtitle =
    'Once you start generating tickets, they will appear here';
  placeholderIcon = 'assets/58x58/no_tickets.svg';
  @Input() hasButton: boolean = false;
  @Input() displayFilterState: boolean = false;
  @Input() currentPageNumber: number = 1;
  @Output() onFilterApply = new EventEmitter<string>();
  @Output() editProject = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<string>();
  @Output() editClient = new EventEmitter<string>();
  @Output() deleteClient = new EventEmitter<string>();
  pageSizeOptions = ['5', '10', '15'];
  @ViewChild('tickets') _ticketsForPagination!: PaginationComponent;
  filterStateMenu!: string;
  @Input() clientsFilter: boolean = false;
  constructor(private router: Router, private _commonService: CommonService) {
    this.hideFilters =
      this.router.url.includes('ticket') || this.router.url.includes('admin-approval/coditas')
    this.router.url.includes('inventory') || this.router.url.includes('manage-workspace');
    this.loanStatusFilter = this.router.url.includes('inventory');
    this.ticketStatusFilter = this.router.url.includes('admin-ticket');
    this.approvalFilter = this.router.url.includes('admin-approval')
    if (this.ticketStatusFilter || this.approvalFilter) {
      this.statusFilter = ['To-Do', 'On-Hold', 'Ongoing', 'Closed', 'All Tickets'];
    }
    if (this.loanStatusFilter) {
      this.statusFilter = [
        'Assigned',
        'Available',
        'Out for Repair',
        'All Assets',
      ];
    }
    if (this.approvalsFilter) {
      this.statusFilter = [
        'Declined',
        'Pending',
        'Approved'
      ]
    }
  }
  private initializeFilterFlags(): void {
    const url = this.router.url;
    this.loanStatusFilter = url.includes('inventory');
    this.ticketStatusFilter = url.includes('admin-ticket');
    this.approvalFilter = url.includes('admin-approval');
    this.approvalsFilter = url.includes('admin-approval') || url.includes('user-approval') || url.includes('employee-approval');
    this.workspaceFilter = url.includes('home/main/dashboard');

    if (this.loanStatusFilter) {
      this.statusFilter = ['Assigned', 'Available', 'Out for Repair', 'All Assets'];
    } else if (this.ticketStatusFilter || this.approvalFilter) {
      this.statusFilter = ['To-Do', 'On-Hold', 'Ongoing', 'Closed', 'All Tickets'];
    } else if (this.approvalsFilter) {
      this.statusFilter = ['Declined', 'Pending', 'Approved'];
    }
  }

  ngDoCheck() {
    const userDetails = JSON.parse(localStorage.getItem('userInfo') as string);
    if (
      userDetails.roles[0] === 'USER' ||
      this.router.url === ROUTES.ADMIN_TICKET_PERSONAL
    ) {
      this.displayColorCode = false;
    } else {
      this.displayColorCode = true;
    }
  }
  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
    this.isUser = user?.roles?.[0] === 'USER';
    this.isAdmin = user?.roles?.[0] === 'ADMIN';
    this.isSemiAdmin = user?.roles?.[0] === 'SEMI-ADMIN';
    this.isEkoAdmin = user?.roles?.[0] === 'EKO-ADMIN';

    this.initializeFilterFlags();
    if (
      this.router.url === ROUTES.ADMIN_TICKET_PERSONAL ||
      this.router.url === ROUTES.ADMIN_APPROVAL_PERSONAL ||
      this.router.url === ROUTES.USER_APPROVAL
    ) {
      this.hideFilters = false;
    }
    if (this.loanStatusFilter) {
      this.getPlaceholderConfig('assets');
    } else if (this.approvalsFilter) {
      this.getPlaceholderConfig('approval');
    } else {
      this.getPlaceholderConfig('tickets');
    }

    const pageCount = sessionStorage.getItem('pageSize');
    if (pageCount) this.pageCount = pageCount;
  }

  showFilterState() {
    if (this.isAdmin) {
      const routerUrl = this.router.url.split('=')[1]?.split('&')[0];
      const wordsNeededToBePresentOnRouterUrl = [
        'ALL',
        'CLOSED',
        'ONGOING',
        'EXTERNAL',
      ];
      if (
        ((wordsNeededToBePresentOnRouterUrl.includes(routerUrl) &&
          this.router.url !== '/home/inventory?status=ALL') ||
          this.router.url === `/home/admin-ticket` ||
          this.router.url.includes('ticketType')) &&
        this.router.url !==
        `/home/admin-ticket/admin-employee-dashboard?ticketType=assigned`
      ) {
        if (this.ticketStatusFilter) {
          this.filterStateOptions = [
            { title: 'Assigned', value: 'assigned' },
            { title: 'All tickets', value: 'all' },
          ];
          this.filterStateMenu = 'all';
        }
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  addStatusClass(status: string) {
    return {
      'badge-ongoing': status === 'ONGOING',
      'badge-todo': status === 'TO_DO',
      'badge-closed': status === 'CLOSED',
      'badge-onhold': status === 'ON_HOLD'
    };
  }

  search(searchData: ISearchData) {
    this.searchData.emit(searchData);
  }

  gotoAssetDetails(AssetId: any) {
    this._commonService.AssetId.next(AssetId);
    this.router.navigate(['/home/inventory/asset-details']);
  }

  paginationEmitter(params: any) {
    paginationChange.next(true);
    this.paginatorEmitter.emit(params);
  }

  pageSizeEmitter(index: number) {
    paginationChange.next(true);
    this.pageSize = +this.pageSizeOptions[index];
    this.pageCount = `${this.pageSize}`;
    sessionStorage.setItem('pageSize', this.pageSize.toString());
    this.pageSizeChange.emit(`${this.pageSize}`);
    this.reload.emit(true);
  }
  getSubtitle(subtitle: string) {
    return subtitle.length > 15 ? subtitle.slice(0, 12) + '...' : subtitle;
  }
  sendFilter(filterType: string) {
    if (!this.hideFilters) {
      this.activeFilter.emit(filterType);
    }
  }
  getPriorityClass(priority: string) {
    if (priority == TICKET_PRIORITIES.HIGH) {
      return 'high';
    } else if (priority == TICKET_PRIORITIES.MEDIUM) {
      return 'medium';
    } else if (priority == TICKET_PRIORITIES.LOW) {
      return 'low';
    } else {
      return '';
    }
  }

  getPlaceholderConfig(type?: string) {
    this.status = this.router.url.split('=')[1];
    if (this.isUser) {
      this.placeholderTitle = 'No tickets generated yet';
      this.placeholderSubtitle =
        'Once you start generating tickets, they will appear here';
    }

    if (!this.isUser && type === 'tickets') {
      this.placeholderIcon = 'assets/58x58/no_assets.svg';

      const placeholder = TICKET_PLACEHOLDERS[this.status as TicketStatus]
        || APPROVAL_PLACEHOLDERS.DEFAULT;

      this.placeholderTitle = placeholder.title;
      this.placeholderSubtitle = placeholder.subtitle;
    } else if (!this.isUser && type === 'assets') {
      this.placeholderIcon = 'assets/58x58/no_assets.svg';

      const placeholder = ASSET_PLACEHOLDERS[this.status as AssetStatus]
        || ASSET_PLACEHOLDERS.DEFAULT;

      this.placeholderTitle = placeholder.title;
      this.placeholderSubtitle = placeholder.subtitle;
    } else if (!this.isUser && type === 'approval') {
      this.placeholderIcon = 'assets/58x58/no_assets.svg';

      const placeholder = APPROVAL_PLACEHOLDERS[this.status as ApprovalStatus]
        || APPROVAL_PLACEHOLDERS.DEFAULT;

      this.placeholderTitle = placeholder.title;
      this.placeholderSubtitle = placeholder.subtitle;
    } else {
      this.placeholderIcon = 'assets/58x58/no_assets.svg';

      const placeholder = ASSET_PLACEHOLDERS[this.status as AssetStatus]
        || APPROVAL_PLACEHOLDERS.DEFAULT;

      this.placeholderTitle = placeholder.title;
      this.placeholderSubtitle = placeholder.subtitle;
    }
  }

  onSelectFilter(filter: any) {
    this.onFilterApply.emit(filter);
  }

  onNavigationById(ticketId: string) {
    this.tableNavigationClick.emit(ticketId);
  }
  onSortAction(fieldName: string) {
    this.onSort.emit(fieldName);
  }
  navigateToWorkspace(workspaceId: string) {
    this.tableNavigationClick.emit(workspaceId);
  }
  onProjectEditFromList(project: any) {
    this.editProject.emit(project)
  }
  onProjectDeleteFromList(project: any) {
    this.deleteProject.emit(project)
  }
  onEditClient(client: any) {
    this.editClient.emit(client)
  }
  onDeleteClient(client: any) {
    this.deleteClient.emit(client)
  }
  onEditVendor(vendor: any) {
    this.editClient.emit(vendor)
  }
  onDeleteVendor(vendor: any) {
    this.deleteClient.emit(vendor)
  }
}
